import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { FormSectionProps } from './types';

export function SalarySection({ register, errors }: FormSectionProps): JSX.Element {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Compensation</h3>
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="space-y-2">
          <Label htmlFor="salaryMin">Minimum Salary</Label>
          <Input id="salaryMin" type="number" {...register('salaryMin')} />
          {errors.salaryMin && <p className="text-sm text-red-500">{errors.salaryMin.message}</p>}
        </div>
        <div className="space-y-2">
          <Label htmlFor="salaryMax">Maximum Salary</Label>
          <Input id="salaryMax" type="number" {...register('salaryMax')} />
          {errors.salaryMax && <p className="text-sm text-red-500">{errors.salaryMax.message}</p>}
        </div>
        <div className="space-y-2">
          <Label htmlFor="salaryCurrency">Currency</Label>
          <Input id="salaryCurrency" {...register('salaryCurrency')} maxLength={3} />
          {errors.salaryCurrency && (
            <p className="text-sm text-red-500">{errors.salaryCurrency.message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
